import React, { useEffect, useState, useMemo } from 'react'
import Config from "../../../config/Config";
import WidgetLoading from '../../../widget/WidgetLoading';
import { InfiniteScroll, List } from 'antd-mobile';
import { sleep } from 'antd-mobile/es/utils/sleep';
import JobCard from './jobCard';
import "./job.scss";
import NoData from '../NoData/index';
import WidgetAjax from '../../../widget/WidgetAjax';
import { Pagination } from 'antd';

const path = Config.getBasePath();

const ScrollCardTable = ({
    info = {}, // 企业信息,
    isEnterprise = false, // 是否是企业详情页
    onCheck, // 点击卡片
    params = {}, // 岗位查询条件参数
    onGetJobListCallback, // 获取岗位列表回调函数
    onHasMoreCallback = () => {}, // 是否加载更多回调函数
}) => {
    const [data, setData] = useState([]);
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(true);
    const [total, setTotal] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [checkValue, setCheckValue] = useState(null);
    const tableParams = useMemo(() => params, [JSON.stringify(params)]);
    // const [prevParams, setPrevParams] = useState(undefined);
    
    // 获取列表数据
    const getJobList = async (num) => {
        await sleep(2000);
        let pageNum = num === 0 ? num + 1 : page + 1;

        setPage(pageNum);
        return await new Promise((resolve) => {
            WidgetAjax.ajax({
                url: path + '/job/search',
                params: {
                    JOBCATEGORY:"1",
                    enterprise_id: info?.id,
                    page: pageNum,
                    records: 5,
                    ...params,
                },
                callback: (res) => {
                  
                   
                    if (res.status == 0) {
                        const list = res.results || [];   // 关键修复③：兜底 undefined
                        setTotal(res.total);
                        if (onGetJobListCallback) {
                            onGetJobListCallback();
                        }

                        if (pageNum == 1) {
                            if (list.length > 0) {
                                setCheckValue(list[0].id);
                                if (onCheck) {
                                    onCheck(list[0].id);
                                }
                            } else {
                                onCheck(undefined);
                            }
                        }
                         setLoading(false);

                        resolve(list);
                    } else {
                         setLoading(false);

                    }
                }
            })
        });
    }
    const loadMore = async (num) => {
        let newData = await getJobList(num);
        if (num === 0 || page === 0) {
            setData([...newData]);
        } else {
            setData([...data, ...newData]);
        }
        setHasMore(newData.length >= 5);
        onHasMoreCallback(newData.length >= 5);
    }
    // 生产列表内容
    const job_box = (data) => {
        return <>
            {
                data && data.length > 0 ?
                    data.map((item) => {
                        return <JobCard data={item} value={checkValue} onCheck={onHandleCheck} />
                    })
                    : null
            }
        </>

    }
    // 点击卡片
    const onHandleCheck = (value) => {
        setCheckValue(value);
        if (onCheck) {
            onCheck(value);
        }
    }
    // 参数变化时重新加载数据
    const doSearch = async (num) => {
        await setData([]);
        setHasMore(true);
        loadMore(num);
    }
    // 监听企业信息
    useEffect(() => {
        if (isEnterprise) {
            if (info.id) {
                setLoading(true);
                doSearch();
            }
        }
    }, [info]);
    
    // 监听params参数变化
    useEffect(() => {
        if (tableParams) {
            setLoading(true);
            doSearch(0);
        }
    }, [tableParams]);

    return <WidgetLoading
        loading={loading}
        style={{
            backgroundColor: 'rgba(255,255,255,0.8)',
        }}
    >
        {
            data && data.length > 0
                ? <>
                    <div component-data="jobScroll">
                        {job_box(data)}
                    </div>
                    <InfiniteScroll hasMore={hasMore} loadMore={loadMore} />
                </>
                : !loading ?
                    <div style={{ backgroundColor: 'rgba(255,255,255,0.8)' }}><NoData width={"230px"} height={'230px'} /></div> : <></>
        }
    </WidgetLoading>
}

export default ScrollCardTable;